import React from 'react';
//import ReactDOM from "react-dom/client";
import preval from 'preval.macro'
import {
  Button,
  Col,
  Container,
  //Alert,
  //Nav,
  //Navbar,
  Row,
  Form,
  //Input,
  Stack
} from 'react-bootstrap';
import '../../App.css';
import utils from '../../utils'
import EcuComps2 from '../../comp/EcuComps2'
import MyEcu from '../../MyEcu';
//import PTextLabel from '../../comp/p/PTextLabel'
//import { wait } from '@testing-library/user-event/dist/utils';
//////import { confirm } from "react-confirm-box";
//import AuthService from '../../services/auth-service';
import LoadingSpinner from "../../comp/gen/LoadingSpinner"
import UserAuthRequired from "../../comp/gen/UserAuthRequired"

// ****************************************************************************

export default class MP_NEUTRO extends React.Component {
  constructor(props) {    
    super(props); 
    // ecu
    this.ecu = new MyEcu(MyEcu.ECU_TYPE.MP48__MP8C, 9600)
    this.ecu.progressChanged = this.ecu_progress_changed.bind(this)
    this.ecu.comPortChanged = this.ecu_com_port_changed.bind(this)
    // ref
    this.client_select = React.createRef()
    this.sub_client_code_text = React.createRef()
    this.id_pcb_w0_text = React.createRef()
    this.id_pcb_w1_text = React.createRef()
    this.id_pcb_select = React.createRef()
    // state
    this.state = { 
      working: 0,
      ecu_comps: [],            
      usb_selected: false,
      usbProductId: "",
      usbVendorId: "",      
    };
    // debug
    if ("serial" in navigator) {
      console.log("supported !") 
    }
  }
  
  ecu_com_port_changed(o) {
    if (o === undefined) {
      this.setState({
        usb_selected: false,
        usbProductId: "",
        usbVendorId: "",
      })
      return 
    }
    this.setState({
      usb_selected: true,
      usbProductId: o.usbProductId,
      usbVendorId: o.usbVendorId,
    })
  }

  ecu_progress_changed(o) {
    //console.log(o)
    if (o.type == "_working") {
      this.setState({
        working: o.data
      })
    } else {
      this.setState(prevState => ({
        ecu_comps: [
          ...prevState.ecu_comps,
          o,
        ]
      }))
    }    
    //console.log("STATE")
    //console.log(this.state)
  }

  async handleButtonClearClick() {
    await this.setState({ ecu_comps: [] })
    console.log(this.state)
  }
  async handleButtonFix_MP48_CLIENT_Click() {

    this.ecu.setEcuType(MyEcu.ECU_TYPE.MP48__MP8C)      
    this.ecu.setBaudRate(9600)
    
    var selected_client = "CLIENT_FC"
    var stay_in_boot_after_fix = false
    console.log("selected_client : " + selected_client)
    console.log("stay_in_boot_after_fix_checked : " + stay_in_boot_after_fix)
    
    var c = utils.getIdPcbFromName("MP48")    
    await this.setState({ ecu_comps: [] })
    this.ecu.fixNeutro(selected_client, "0000", c.w0, c.w1)
  }  
  async handleButtonReadEcuInfoClick() {
    await this.setState({ ecu_comps: [] })
    this.ecu.readEcuInfo()
  }
  async handleButtonSetComPortClick() {
    await this.setState({ ecu_comps: [] })
    this.ecu.selectComPort()
  }
  async handleButtonSetProdMarkerClick() {
    // const options = {
    //   labels: {
    //     confirmable: "Confirm",
    //     cancellable: "Cancel"
    //   }
    // }
    if (!window.confirm("Are you sure?")) return 
    await this.setState({ ecu_comps: [] })
    this.ecu.setProdMarker(0x01)
  }
  
  render() { 
    //console.log(this.props)
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRole(this.props.authStatus.user, "NEUTRO")) return <UserAuthRequired notallowed />

    var buttons_en = !(this.state.working === 1)
    return (
      <>          
        <Container>            
            <Row style={{ marginTop: "15px" }}> 
              <Col>
                <Row>
                  <Col>
                    <img src={process.env.PUBLIC_URL + '/logo_landi.png'} className="App-logo2" alt="logo" />
                  </Col>
                  <Col>
                    <p>Build Date: {preval`module.exports = new Date().toLocaleString();`}</p>
                    <Button 
                        variant="outline-secondary" 
                        disabled={!buttons_en}  
                        onClick={e => this.handleButtonSetComPortClick(e)}>SET COM PORT</Button>                    
                    {/* <PTextLabel visible={this.state.usb_selected} label="usbProductId" value={this.state.usbProductId} />
                    <PTextLabel visible={this.state.usb_selected} label="usbVendorId" value={this.state.usbVendorId} /> */}
                  </Col>
                </Row>
                <Stack direction='horizontal' gap={3}>
                </Stack>
              </Col>
              <Col>
                <Stack gap={3}>
                  <Button 
                      variant="success" 
                      disabled={!buttons_en} 
                      onClick={e => this.handleButtonReadEcuInfoClick(e)}>READ ECU INFO</Button>
                  <Button 
                      variant="success" 
                      disabled={!buttons_en} 
                      onClick={e => this.handleButtonFix_MP48_CLIENT_Click(e)}>FIX MP48 CLIENT</Button>
                </Stack>
              </Col> 
            </Row>
            <Row style={{ marginTop: "15px" }}>
              <Col>
                <Stack gap={3}>
                  <Row>
                    <Col>  
                      <Form.Select disabled defaultValue={this.ecu.ecu_type} aria-label="">
                        <option disabled value="0">Select an option...</option>
                        <option value={MyEcu.ECU_TYPE.MP48__MP8C}>MP48, MP8C</option>
                        <option value={MyEcu.ECU_TYPE.MP32__MP48_OBD}>MP32, MP48 OBD</option>
                        <option value={MyEcu.ECU_TYPE.MP32_NEW}>MP32 New (EXR)</option>
                        <option value={MyEcu.ECU_TYPE.DI60}>DI60</option>
                      </Form.Select>
                    </Col>
                  </Row>                                    
                  <Row>
                    <Col>
                      <Button variant="primary" disabled>
                        Do not press this button ...
                      </Button>
                      {' '}
                      <Button 
                          variant="outline-secondary" 
                          disabled={!buttons_en}  
                          onClick={e => this.handleButtonSetProdMarkerClick(e)}>SET PROD MARKER</Button>
                    </Col>
                  </Row>
                </Stack>
              </Col>

              <Col>      
                <Stack gap={3}>        
                  <Button 
                    variant="info" 
                    onClick={e => this.handleButtonClearClick(e)}>CLEAR RESULT</Button>                  
                  <EcuComps2 ecu_comps={this.state.ecu_comps} />
                </Stack>
              </Col>
            </Row>
        </Container>        
      </>
    )
  }
}
